import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-stairs-icon"
};
const _hoisted_1 = {
  width: "19",
  height: "16",
  viewBox: "0 0 19 16",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_3154_575)" }, [
  /* @__PURE__ */ createElementVNode("path", { d: "M18.7778 1.75C18.7778 2.16406 18.4419 2.5 18.0278 2.5H14.2778V6.25C14.2778 6.66406 13.9419 7 13.5278 7H10.2778V10.25C10.2778 10.6641 9.94189 11 9.52783 11H6.27783V14.25C6.27783 14.6641 5.94189 15 5.52783 15H1.52783C1.11377 15 0.777832 14.6641 0.777832 14.25C0.777832 13.8359 1.11377 13.5 1.52783 13.5H4.77783V10.25C4.77783 9.83594 5.11377 9.5 5.52783 9.5H8.77783V6.25C8.77783 5.83594 9.11377 5.5 9.52783 5.5H12.7778V1.75C12.7778 1.33594 13.1138 1 13.5278 1H18.0278C18.4419 1 18.7778 1.33594 18.7778 1.75Z" })
], -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("defs", null, [
  /* @__PURE__ */ createElementVNode("clipPath", { id: "clip0_3154_575" }, [
    /* @__PURE__ */ createElementVNode("rect", {
      width: "18",
      height: "16",
      fill: "white",
      transform: "translate(0.777832)"
    })
  ])
], -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const uikitStairsIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitStairsIcon as default
};
//# sourceMappingURL=uikit-stairs-icon.vue.es.js.map
